var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuvP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "suv",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24",
    "data-name": "Rect\\xE1ngulo 24",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "car-estate",
    d: "M3.369,9H15.518l2.8,3.738H20.19a1.863,1.863,0,0,1,1.869,1.869v2.8H20.19a2.8,2.8,0,0,1-5.607,0H8.976a2.8,2.8,0,1,1-5.607,0H1.5V10.869A1.863,1.863,0,0,1,3.369,9M2.9,10.4v2.336h7.476V10.4H2.9m8.878,0v2.336h4.8L14.817,10.4H11.78M6.173,16.009a1.4,1.4,0,1,0,1.4,1.4,1.4,1.4,0,0,0-1.4-1.4m11.214,0a1.4,1.4,0,1,0,1.4,1.4A1.4,1.4,0,0,0,17.387,16.009Z",
    transform: "translate(0.5 -3)",
    fill: "#ff5821"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuvP);
export default __webpack_public_path__ + "static/media/suv_p.627d447873f6e3a90ec6d2241e60ec7c.svg";
export { ForwardRef as ReactComponent };